import { render } from "./indexCheckout.vue?vue&type=template&id=2a7e2e40"
import script from "./indexCheckout.vue?vue&type=script&lang=js"
export * from "./indexCheckout.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__